import React from 'react';
import type { ActivityIndicatorProps } from 'react-native';
import { ActivityIndicator } from './rn';
import { useTranslation } from '../i18n/I18nContext';

// React Native'in varsayılan iOS erişilebilirlik açıklaması uygulama dilinden
// bağımsız olarak "In progress" kalabiliyor. Bütün kullanıcıya dönük yükleyiciler
// aynı yerelleştirilmiş etiketi bu bileşenden alır.
export default function LoadingIndicator({ accessibilityLabel, ...props }: ActivityIndicatorProps) {
  const { t } = useTranslation();

  return (
    <ActivityIndicator
      {...props}
      accessible
      accessibilityRole="progressbar"
      accessibilityLabel={accessibilityLabel ?? t('common.loading')}
    />
  );
}
